const withMeterList = [
  { value: null, name: '　' },
  { value: false, name: '不扣電表租費' },
  { value: true, name: '扣電表租費' }
];
export default withMeterList;
